import {css} from '../theme/css'

export const classes = {
  root: css`
    // возможно перепишем исходя из тикета MAPSAPI-16396
    & .ymaps3x0--control {
      background: transparent;
      box-shadow: none;
    }
  `,
}
